import { ActionContext } from "vuex";
// import TYPES from './types'
import { RootState } from "./index";
import request from "~~/utils/request";
import { ILeadData } from "~/types/lead";
import { lead as api } from "~~/const/apis";

interface State {}

export const state = (): State => ({});

export const mutations = {};

export const actions = {
  createLead(
    { state, commit, rootState }: ActionContext<State, RootState>,
    data: ILeadData
  ) {
    const countryCode = rootState.user?.userLocation?.Country?.Code;
    return request.post(api.create_lead, data, {
      headers: {
        "shark-screen-width": screen.width,
        "shark-screen-height": screen.height,
        "shark-browser-language": navigator.language,
        "shark-browser-platform": navigator.platform,
        "shark-browser-name": navigator.appCodeName,
        "shark-browser-version": navigator.appVersion,
        "shark-browser-online": navigator.onLine,
        "shark-timezone-name": Intl?.DateTimeFormat()?.resolvedOptions()
          .timeZone,
        "shark-priority-region": countryCode
      }
    });
  }
};
